<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-edit text-primary"></i></a>

    <b-modal ref="modal" hide-footer title="Document type - update">
        <div class="d-block">
          <form>

            <div class="form-group">
                <input type="text" 
                    class="form-control" 
                    id="name" 
                    autocomplete="off_type"
                    placeholder=" "
                    v-model="name">
              <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
              <label for="name">Type</label>
            </div>
           <b-form-checkbox class="ml1500"
                switch
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Status
            </b-form-checkbox>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="button" @click="fnUpdate()" class="btn btn-success btn-sm">Update</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as documentTypeService from '../../services/documentType.service';
    export default {
        name:"ModalDocumentTypeEdit",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                id:'',
                name:'',
                status:'',
            }
        },
        computed:{
            ...mapGetters(['gettDocumentTypeAll']),
        },
        methods:{
            ...mapActions(['fetchDocumentTypeAll']),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            fnGetValue(props){
                this.id = props.rowData.id;
                this.status = props.rowData.status;
                this.name = props.rowData.name;
            },

            fnUpdate:async function(){
                const obj = {
                    "name":this.name,
                    "status":this.status
                }

                try{
                    const response = await documentTypeService.update(this.id, obj);
                    this.fetchDocumentTypeAll();
                    messageService.fnSweetAlertSuccessToast('Document type', 'Updated successfully ');
                    this.hideModal();

                }catch(error){
                    messageService.fnSweetAlertErrorToast('Document type - update', error.response.data.message);
                }

                this.id = ''; 
                this.name = '';
                this.status ='';
            }
        }
    }
</script>